<template>
	<div>

		<el-row>

      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item>
          <el-checkbox v-model="radio" @change="changeRadioAction" >{{checkBoxMsg}}</el-checkbox>
        </el-form-item>
        <!-- <el-form-item label="当前月份">
          <el-date-picker v-model="formInline.payDate" type="month" placeholder="选择当前月份">
          </el-date-picker>
        </el-form-item> -->

        <el-form-item label="统计类型">
          <el-select v-model="formInline.queryType" style="width:120px"  placeholder="请选择">
            <el-option label="成本中心" value="COST_CENTER"></el-option>
            <el-option label="分公司" value="ORG_ID"></el-option>
            <el-option label="部门" value="DEPT_ID"></el-option>

          </el-select>
        </el-form-item>
        <el-form-item label="当前月份">
          <el-date-picker v-model="formInline.payDate" style="width:145px"  type="month" value-format="yyyy-MM" placeholder="选择当前月份">
          </el-date-picker>
        </el-form-item>
				<el-form-item label="比较月份">
					<el-date-picker v-model="formInline.historyDate" style="width: 150px;" type="month" value-format="yyyy-MM" placeholder="选择比较月份">
					</el-date-picker>
				</el-form-item>

<!--
				<el-form-item label="统计日期类型">
					<el-select v-model="formInline.type" placeholder="请选择统计日期类型" style="width: 180px;">
						<el-option label="税金所属月份" value="1"></el-option>
						<el-option label="工资所属月份" value="2"></el-option>
&lt;!&ndash;
						<el-option label="开票所属月份" value="3"></el-option>
&ndash;&gt;
						<el-option label="发放月份" value="4"></el-option>
						</el-select>
				</el-form-item>
-->
				<el-form-item>
					<el-button type="primary" @click="onSubmit">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="toColumnPage">自定义表头</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="toExport">导出</el-button>
				</el-form-item>

      </el-form>
		</el-row>
		<div style="height: calc(100vh - 212px);">
			<vxe-grid
        id="annualWage"
						resizable
        show-footer
						auto-resize
						border
						show-overflow
        :show-header-overflow="true"
        :footer-method="footerMethod"
        :custom-config="{storage: true}"
						ref="xGrid"
            align="center"
						width="100%"
						height="100%"
						:loading="loading"
						:columns="tableColumn"
						:data.sync="tableData"
					>
        <template v-slot:empty>
                    <span>
                      <svg class="icon icon-kong" aria-hidden="true" style="font-size: 40px;color: #999">
                            <use xlink:href="#icon-kong"></use>
                          </svg>
                      <p class="noData">暂无数据</p>
                    </span>
        </template>
					</vxe-grid>
		</div>
	<vxe-pager
			:loading="loading"
			:current-page="formInline.page"
			:page-size="formInline.limit"
			:total="formInline.total"
			:layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']"
			@page-change="handlePageChange">
		</vxe-pager>

    <el-dialog
      ref=""
      id="dialog1"
      width="740px"
      v-dialogDrag
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="自定义表头"
      :visible.sync="dialogheaderVisible"
    >
      <customHeader v-if="dialogheaderVisible" :headerList.sync="headerList" :headerData.sync="headerData"
      >

      </customHeader>
      <div
        class="marginTop30"
        style="text-align: center"
      >
        <el-button
          type="primary"
          @click="saveCusHeader()"
        >
          确认
        </el-button>
        <el-button @click="dialogheaderVisible = false">
          取消
        </el-button>
      </div>
    </el-dialog>
	</div>
</template>

<script>
	import customHeader from "@/wage-components/ciic-custom-table-header/index";
	import {
		getCostCenterComparisonColumns,
    addCostCenterComparison,
		getCostCenterComparisonColumnList
	} from "@/api/report/report.js";
  import {bspTableFilter} from "../../../filters";
  import {mapGetters} from "vuex";
	import XEUtils from 'xe-utils';
	import exportMethod from '@/util/export.js'
  import {deepCopy} from '@/util/util';
  import {getOrgInfo} from "@/api/org/org";
  import store from "@/store";

	export default {
		components: {customHeader},
		created() {
			this._getCostCenterComparisonColumns(this.formInline);
			this._getCostCenterComparisonColumnList(this.formInline);
		},
		data() {
			return {
				dialogheaderVisible: false,
        radio: false,
        checkBoxMsg:'隐藏空列',
				formInline: {
					queryType: 'COST_CENTER',
					historyDate: '',
          payDate: '',
          monthType: '2',
					limit: 20,
					page: 1,
					total: 0
				},
				headerList:[],
				headerData:[],
				tableColumn:[],
        hiddenColumns:[],//可以隐藏的列
        expHiddenColumns:[],//需要隐藏的列
        sumListCode:[],//需要合计的列信息
        orgMap:{},//组织结构map
        tableData:[]
			}
		},
    computed:{
      ...mapGetters([
        'dicts',
      ]),
    },
		methods: {
      //重置
      resetAction(){
        this.hidden = false;
        this.$refs.xGrid.resetColumn();
      },
      changeRadioAction(){
        if (this.radio) {
          this.hiddenAction();//隐藏
          //this.checkBoxMsg='重置';
        }else{
          this.resetAction();//重置
          //this.checkBoxMsg='隐藏空列';
        }
      },
      //隐藏
      hiddenAction(){
        this.expHiddenColumns = []; // 清空
        if(this.hiddenColumns && this.hiddenColumns.length>0){
          this.hidden=true;
          // 先收集所有需要隐藏的列对象
          const allCols = [];
          this.tableColumn.forEach(col => {
            // 检查自身field
            if (col.field && !this.hiddenColumns.includes(col.field)) {
              allCols.push(col);
            }
            // 检查分组列
            if (col.grounpColumns && Array.isArray(col.grounpColumns)) {
              const hasChild = col.grounpColumns.some(sub => !this.hiddenColumns.includes(sub.field));
              if (hasChild) {
                allCols.push(col);
              }
            }
          });
          // 去重
          this.expHiddenColumns = [...new Set(allCols)];
          // 然后执行隐藏操作，遍历hiddenColumns
          this.hiddenColumns.forEach(filed => {
            this.$refs.xGrid.hideColumn(this.$refs.xGrid.getColumnByField(filed));
          });
        }
      },
      footerMethod ({ columns, data }) {
        this.hiddenColumns = [];
        const result = [
          columns.map((column, columnIndex) => {

            if(data&&data.length>0){
              let columFiled = column.property;
              let result = XEUtils.every(data,(data)=>{
                return data[columFiled] ===0 || data[columFiled]===null
                  || data[columFiled] === '0'|| data[columFiled] === '0.0'|| data[columFiled] === '0.00'
              })
              if(result){
                this.hiddenColumns.push(columFiled)
              }
            }

            if (columnIndex === 0) {
              return '合计'
            }
            if (this.sumListCode.includes(column.property)) {
              return XEUtils.sum(data, column.property)
            }
            return null
          })
        ]

        this.$nextTick(() => {
          if (this.radio) {
            this.hiddenAction();
          }
        });
        return result;
      },
  //跳转自定义表头设置
      toColumnPage(){
        debugger;
        console.log(this.headerList);
        this.dialogheaderVisible = true
      },
			saveCusHeader(){
        addCostCenterComparison({entityList:this.headerList}).then(res=>{
					this.dialogheaderVisible = false;
          this._getCostCenterComparisonColumns(this.formInline);
          this._getCostCenterComparisonColumnList(this.formInline);
        })
			},
      _getCompanyOrg(cusId){
        getOrgInfo(cusId).then(res=>{
          let orgData = res.data;//查询机构树
          let map = {};
          for (let i = 0,l=orgData.length; i <l; i++) {
            map[orgData[i].id]=orgData[i].orgName;//id:orgName结构存储
          }
          this.orgMap =  map;
        })
      },
      onSubmit(){
        if(this.formInline.monthType){
          this._getCompanyOrg(store.getters.cusId);
          this._getCostCenterComparisonColumns(this.formInline);
				  this._getCostCenterComparisonColumnList(this.formInline);

        }else {
          this.$message.error('请选择统计日期类型');

        }
			},
			handlePageChange({ currentPage, pageSize }){
					this.formInline.page = currentPage;
							this.formInline.limit = pageSize;
							this._getWageComparisonColumnList(this.formInline);
				},
				_getCostCenterComparisonColumnList(obj){
					getCostCenterComparisonColumnList(obj).then(res => {
					   	this.tableData = res.data.records;
            for (let i=0;i<res.data.records.length;i++){
              let idCardType= bspTableFilter(res.data.records[i].idCardType,{'1':'dict',2:this.dicts})
              this.$set(this.tableData[i],'idCardType',idCardType)
              if(this.formInline.queryType=='ORG_ID'){
                let orgId= bspTableFilter(res.data.records[i].orgId,{'1':'refs','3':this.orgMap})
                this.$set(this.tableData[i],'orgId',orgId)
              }
              if(this.formInline.queryType=='DEPT_ID'){
                let deptId= bspTableFilter(res.data.records[i].deptId,{'1':'refs','3':this.orgMap})
                this.$set(this.tableData[i],'deptId',deptId)
              }
            }
								this.formInline.total = res.data.total;
						})
				},
			_getCostCenterComparisonColumns(obj){
				getCostCenterComparisonColumns(obj).then(res => {
				this.headerData = res.data.checkLists;
				this.headerList = res.data.itemDatasList.length>0?res.data.itemDatasList:res.data.sysDatas;
				this.sumListCode = res.data.sumListCode;
          let records = res.data.itemDatas.length>0?res.data.itemDatas:res.data.sysLists;
					let columns = records.map(column =>{
						column.title = column.itemNameCh?column.itemNameCh:column.title;
						column.field = column.field;
						column.minWidth = 100;
						return column
					});
          if(this.formInline.historyDate!='' && this.formInline.payDate!=''){

            if(this.formInline.queryType=='COST_CENTER'){
              columns.unshift({ title:'成本中心', field:'costCenter',width: 100 ,fixed:'left' });
            }
            if(this.formInline.queryType=='ORG_ID'){
              columns.unshift({ title:'分公司', field:'orgId',width: 100 ,fixed:'left' });
            }
            if(this.formInline.queryType=='DEPT_ID'){
              columns.unshift({ title:'部门', field:'deptId',width: 100 ,fixed:'left' });
            }
          }
          columns.unshift({ title:'序号',type: 'seq', width: 50,fixed:'left'  });
          this.tableColumn = columns;
				})
			},
			toExport(){
        let cols = [];
        if(this.radio && this.expHiddenColumns && this.expHiddenColumns.length > 0){
          cols=this.$clone(this.expHiddenColumns);
        } else {
          cols=this.$clone(this.tableColumn);
        }
				let column = deepCopy(cols);
				column.splice(0,1);
				//单独处理第一列
				if(this.formInline.queryType=='COST_CENTER'){
					column.splice(0,1,{
						title:'成本中心', field:'costCenter',width: 100 ,fixed:'left',colIndex:1,grounpColumns:[
							{title:'成本中心', field:'costCenter',width: 100 ,fixed:'left',colIndex:1}
						]
					})
				}
				else if(this.formInline.queryType=='ORG_ID'){
					column.splice(0,1,{
						title:'分公司', field:'orgId',width: 100 ,fixed:'left',colIndex:1,grounpColumns:[
							{title:'分公司', field:'orgId',width: 100 ,fixed:'left'}
						]
					})
				}
				else if(this.formInline.queryType=='DEPT_ID'){
					column.splice(0,1,{
 						title:'部门', field:'deptId',width: 100 ,fixed:'left',colIndex:1,grounpColumns:[
							{title:'部门', field:'deptId',width: 100 ,fixed:'left',colIndex:1}
						]
 					})
				}

				exportMethod(
				{
					columns: column,
					type: "excel",
					beanName: "reportServiceImpl",
					methodName: "getCostCenterComparisonColumnList",
					queryType: this.formInline.queryType,
					payDate: this.formInline.payDate,
					historyDate:this.formInline.historyDate,
					monthType: this.formInline.monthType,
					limit: this.formInline.limit,
					page: this.formInline.page,
					headerRowNum: 2,
					isSort:true,
					fileName: "成本中心对比表",
					fileType: ".xls",
				},
				"/wage",true
				);
			},
		}
	}
</script>
<style scoped>
	.downLoad,
	.del {
		font-size: 12px;
		margin-left: 20px;
		font-weight: 500;
		color: rgba(64, 158, 255, 1);
		line-height: 17px;
		cursor: pointer;
	}

	.fileName {
		padding-bottom: 10px;
		line-height: 17px;
	}

	.fileName img,
	.fileName span {
		vertical-align: middle;
	}

	.fileName span {
		height: 17px;
		line-height: 17px;
	}

	.fileName span.oneOwner {
		padding-left: 42px;
	}

	.fileName img {
		margin-right: 20px;
	}

	.fileName:nth-last-of-type(1) {
		padding-bottom: 0;
	}

	.el-row {
		text-align: right;
		margin-bottom: 10px;
	}

	.upload {
		font-size: 12px;
		margin-right: 50px;
		font-weight: 500;
		color: rgba(64, 158, 255, 1);
		line-height: 17px;
	}

	.el-form--inline>>>.el-form-item {
		margin-bottom: 0;
	}
</style>
